<template>
  <div id="app">
    <!-- 根据设备类型显示不同的布局 -->
    <div v-if="isMobile" class="mobile-layout">
      <!-- 移动端布局 -->
      <router-view />
    </div>
    <div v-else class="desktop-layout">
      <!-- 桌面端布局 -->
      <el-container>
        <el-header class="app-header">
          <div class="header-content">
            <div class="logo">
              <i class="el-icon-basketball"></i>
              <span>鸟类环志信息管理系统</span>
            </div>
            <div class="nav-menu">
              <el-menu
                mode="horizontal"
                :default-active="$route.path"
                router
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                :collapse="false"
              >
                <el-menu-item index="/home">首页</el-menu-item>
                <el-menu-item index="/records">记录列表</el-menu-item>
              </el-menu>
            </div>
          </div>
        </el-header>
        <el-main class="app-main">
          <router-view />
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'App',
  setup() {
    const store = useStore()

    // 检测设备类型
    const isMobile = computed(() => store.getters.isMobile)

    // 检测屏幕尺寸变化
    const handleResize = () => {
      const width = window.innerWidth
      store.commit('setDeviceType', width <= 768)
    }

    onMounted(() => {
      handleResize()
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })

    return {
      isMobile
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  min-height: 100vh;
}

.desktop-layout {
  min-height: 100vh;

  // Element Plus 容器样式覆盖
  ::v-deep .el-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-header {
    flex-shrink: 0;
  }

  ::v-deep .el-main {
    flex: 1;
    overflow: visible !important; // 允许内容超出，让页面整体滚动
  }

  .app-header {
    background-color: #545c64;
    height: 60px !important;
    padding: 0;

    .header-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 0 20px;

      .logo {
        display: flex;
        align-items: center;
        color: white;
        font-size: 18px;
        font-weight: bold;

        i {
          margin-right: 8px;
          font-size: 24px;
        }
      }

      .nav-menu {
        .el-menu {
          border-bottom: none;
        }
        
        // 确保菜单项直接显示，不折叠到"更多"菜单
        ::v-deep .el-menu--horizontal .el-submenu__title {
          display: none;
        }
      }
    }
  }

  .app-main {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: calc(100vh - 60px); // 最小高度 = 视口高度 - 头部高度
  }
}

.mobile-layout {
  height: 100vh;
  /* 移动端也需要可滚动，否则列表超出一屏无法下滑 */
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
